import React from 'react';
import { createPortal } from 'react-dom';
import { Icon } from 'venn-ui-kit';

interface AllocationSearchWrapperProps {
  nodeRef: React.RefObject<HTMLDivElement>;
  onClose: () => void;
  title: string | React.ReactNode;
  children: React.ReactNode;
}

export const AllocationSearchWrapper: React.FC<AllocationSearchWrapperProps> = ({
  nodeRef,
  onClose,
  title,
  children,
}) => {
  const boundingRect = nodeRef.current?.getBoundingClientRect();

  return createPortal(
    <div className="fixed z-50 inset-0 pointer-events-none">
      <div
        className="fixed bg-white border border-solid border-venn-grey-30 rounded-[8px] shadow-[0_3px_6px_0_rgba(0,0,0,0.25)] w-[700px] max-h-[500px] flex flex-col pointer-events-auto"
        style={boundingRect ? { top: boundingRect.bottom, left: boundingRect.left + 12 } : undefined}
      >
        <div className="py-[16px] flex flex-col h-full overflow-hidden">
          <div className="flex justify-between items-center px-[16px] mb-[16px]">
            <h2 className="font-bold text-[16px] m-0 text-venn-black">{title}</h2>
            <button
              type="button"
              onClick={onClose}
              aria-label="Close modal"
              className="qa-rcm-search-close bg-transparent border-none cursor-pointer px-[8px] py-[4px] text-venn-black text-[18px] hover:text-gray-600 focus:outline focus:outline-2 focus:outline-blue-500"
            >
              <Icon type="times" />
            </button>
          </div>
          {children}
        </div>
      </div>
    </div>,
    document.body,
  );
};
